import { computed } from 'vue'

import type { MobilePlanOffer } from '@backmarket/http-api/src/api-specs-partnerships/mobile-plan/types/mobile-plan-offers'

import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useSelectedMobilePlan() {
  const { data: product } = useFetchProduct()
  const { mobilePlan: mobilePlanOfferId } = useUrlParams()

  return computed(() => {
    if (!mobilePlanOfferId.value) return undefined

    return product.value?.includedServiceOffers.mobilePlans.find(
      (mobilePlan: MobilePlanOffer) =>
        mobilePlan.id === mobilePlanOfferId.value,
    )
  })
}
